export default "__VITE_ASSET__6442fe45__"